const getImageUrl = (objectName) => {
	return `https://storage.googleapis.com/tiny-texts/mms/${objectName}`;
};

export default getImageUrl;
